import { handleResponse, handleError, getProductApiUrl, queryValue } from "./apiUtils";
import getRequestOptions from './authorizationUtils';
import axios from 'axios';

// Served by the tenant's sugar instance (module Products), not by the ProductUnit azure
// function app any more. The request and response shapes are unchanged.

export function ReadProductUnits(filter, sort, page, cancelToken) {
    const options = getRequestOptions(cancelToken);
    return axios.get(getProductApiUrl() + `JSONProductUnitGetAll&filter=${queryValue(filter)}&sort=${queryValue(sort)}&page=${queryValue(page)}`, options)
        .then(handleResponse)
        .catch(handleError);
}

export function ReadProductUnitsBatch(batch, cancelToken) {
    const options = getRequestOptions(cancelToken);
    return axios.post(getProductApiUrl() + `JSONProductUnitGetBatch`, batch, options)
        .then(handleResponse)
        .catch(handleError);
}

export function ReadProductUnit(id) {
    const options = getRequestOptions();
    return axios.get(getProductApiUrl() + `JSONProductUnitGet&id=${queryValue(id)}`, options)
        .then(handleResponse)
        .catch(handleError);
}

export function updateProductUnit(productGroup) {
    const options = getRequestOptions();
    return axios.post(getProductApiUrl() + `JSONProductUnitPost`, productGroup, options)
        .then(handleResponse)
        .catch(handleError);
}
